module.exports = __webpack_public_path__ + "04_veryshort_black.522fd68e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_veryshort_black.png
// module id = zn0b
// module chunks = 0